/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

///////////////////////////////////////////////////////////
/////////////////// BAND MATH /////////////////////////////
///////////////////////////////////////////////////////////

import * as Blockly from 'blockly/core';
import 'blockly/python';

Blockly.Blocks['analyse_math_constant_overriden'] = {
    init: function () {
        let CONSTANTS =
            [['\u03c0', 'PI'],
            ['e', 'E'],
            ['\u03c6', 'GOLDEN_RATIO'],
            ['sqrt(2)', 'SQRT2'],
            ['sqrt(\u00bd)', 'SQRT1_2'],
            ['\u221e', 'INFINITY']];
        this.setHelpUrl(Blockly.Msg.MATH_CONSTANT_HELPURL);
        this.setStyle('bandMath');
        this.setOutput(true, 'band_math_expression');
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown(CONSTANTS), 'CONSTANT');
        this.setTooltip(Blockly.Msg.MATH_CONSTANT_TOOLTIP);
    }
};
